import { Component, OnInit } from '@angular/core';
import { MeModel } from '../../../models/me.model';
import { MeService } from '../../../services/me.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Validators, UntypedFormBuilder, UntypedFormGroup, ValidationErrors } from '@angular/forms';
import swal from 'sweetalert2';
import { AuthService } from '../../../services/auth.service';
import { PasswordPolicyValidator } from "../../../directives/security-policy-validator.directive";

@Component({
  selector: 'account-detail',
  templateUrl: './account-detail.component.html'
})
export class AccountDetailComponent implements OnInit {

  user: MeModel;

  form: UntypedFormGroup;
  emails: UntypedFormGroup;
  passwords: UntypedFormGroup;
  features: UntypedFormGroup;
  submitting: boolean = false;
  submitted: boolean = false;

  constructor(
    private fb: UntypedFormBuilder,
    private meService: MeService,
    private router: Router
  ) { }

  ngOnInit() {

    this.form = this.fb.group({
      'firstName': [null, Validators.compose([Validators.required, Validators.maxLength(200)])],
      'lastName': [null, Validators.compose([Validators.required, Validators.maxLength(200)])],
      'jobTitle': [null, Validators.compose([Validators.required, Validators.maxLength(200)])],
      'phoneNumber': [null, Validators.compose([Validators.required, Validators.maxLength(200)])],
      'emails': this.fb.group({
        'email': [null, Validators.compose([Validators.required, Validators.maxLength(200), Validators.email])],
        'confirmEmail': [null]
      }),
      'passwords': this.fb.group({
        'oldPassword': [null, Validators.compose([Validators.maxLength(200)])],
        'password': [null],
        'passwordAgain': [null]
      })
    });

    this.emails = this.form.controls['emails'] as UntypedFormGroup;
    this.passwords = this.form.controls["passwords"] as UntypedFormGroup;

    this.meService.get().then((result) => {
      this.user = result;

      this.form.controls['firstName'].setValue(this.user.firstName);
      this.form.controls['lastName'].setValue(this.user.lastName);
      this.form.controls['jobTitle'].setValue(this.user.jobTitle);
      this.form.controls['phoneNumber'].setValue(this.user.phoneNumber);
      this.emails.controls['email'].setValue(this.user.email);
    });

  }

  passwordsMatch(group: UntypedFormGroup): ValidationErrors | null {
    let match = group.controls['password'].value === group.controls['passwordAgain'].value;
    return match ? null : { 'passwordsMatch': { value: group.controls['passwordAgain'].value } };
    }

    newPasswordMatch(group: UntypedFormGroup): ValidationErrors | null {
        let match = group.controls['oldPassword'].value !== group.controls['password'].value;
        return match ? null : { 'passwordsMatch': { value: group.controls['password'].value } };
    }

  oldPasswordRequired(group: UntypedFormGroup): ValidationErrors | null {
    var regexp = /^$/g;
    let isEmptyy = regexp.test(group.value);
    return isEmptyy ? { 'oldPasswordRequired': { value: true } } : null;
  }

  passwordRequired(group: UntypedFormGroup): ValidationErrors | null {
    let hasValue = group.value == '' || group.value == null ? false : true;
    return hasValue ? null : { 'passwordRequired': { value: true } };
  }

  onPasswordChange() {
    (this.form.controls.passwords as UntypedFormGroup).setValidators(this.passwordsMatch);
    this.passwords.controls.oldPassword.setValidators(this.oldPasswordRequired);
    this.passwords.controls.password.setValidators([this.passwordRequired, PasswordPolicyValidator]);

    this.passwordsMatch(this.passwords);
    this.oldPasswordRequired(this.passwords);
    this.passwordRequired(this.passwords);
  }

  onEmailChange() {
    (this.form.controls.emails as UntypedFormGroup).setValidators(this.validateEmailConfirmation);

    this.validateEmailConfirmation(this.emails);
  }

  validateEmailConfirmation(emailsFormGroup: UntypedFormGroup) {
    var email = emailsFormGroup.controls['email'];
    var confirmEmail = emailsFormGroup.controls['confirmEmail'];

    if (email.value !== confirmEmail.value) {
      confirmEmail.setErrors({ validateEmailConfirmation: true });
    }

    return null;
  }

  submit(form: UntypedFormGroup) {

    if (this.submitting) {
      return;
    }

    this.submitted = true;

    if (form.invalid) {
      return;
    }

    this.submitting = true;

    form.disable();

    var handleSuccess = (model: MeModel) => {

      swal({
        title: 'Success',
        text: 'User saved',
        type: 'success'
      });

      this.user = model;
      this.submitting = false;
      form.enable();

      // back to account detail
      this.router.navigate(["/portal/account/me"]);

    };

    var handleError = (error) => {
      this.submitting = false;
      form.enable();

      swal({
        title: 'Error',
        text: error.description,
        type: 'error'
      });
    }

    var model = {
      FirstName: form.controls.firstName.value,
      LastName: form.controls.lastName.value,
      Email: (form.controls.emails as UntypedFormGroup).controls.email.value,
      JobTitle: form.controls.jobTitle.value,
      PhoneNumber: form.controls.phoneNumber.value,
      oldPassword: (form.controls.passwords as UntypedFormGroup).controls.oldPassword.value,
      password: (form.controls.passwords as UntypedFormGroup).controls.password.value
    }

    this.meService.update(model).then(handleSuccess).catch(handleError);
  }

}
